import { z } from "zod";

const cursor = z.string().min(1);
const smsChange = {
  cursor,
  operationId: z.string().min(1),
  smsId: z.string().min(1),
};

export const contactSmsStreamFrameSchema = z.discriminatedUnion("type", [
  z.object({ type: z.literal("stream.ready"), headCursor: cursor }).strict(),
  z
    .object({ type: z.literal("stream.heartbeat"), headCursor: cursor })
    .strict(),
  z
    .object({
      type: z.literal("stream.resync_required"),
      reason: z.string().min(1),
    })
    .strict(),
  z.object({ type: z.literal("stream.shutdown") }).strict(),
  z.object({ type: z.literal("sms.created"), ...smsChange }).strict(),
  z.object({ type: z.literal("sms.updated"), ...smsChange }).strict(),
]);

export type ContactSmsChangeFrame = Extract<
  z.infer<typeof contactSmsStreamFrameSchema>,
  { cursor: string }
>;
